import { useState } from "react"
import Header from './components/Header'
import Tasks from './components/Tasks'
import AddTask from './components/AddTask'

const App = () => { 
  //we can use variables
  const [showAddTask, setShowAddTask] = useState (false)
  const [tasks, setTasks] = useState ([
    {
      id: 1,
      text: 'Meeting ',
      day: 'July 19th at 11:30am',
      reminder: true,
  
  },
  {
      id: 2,
      text: 'Meeting at work',
      day: 'June 21th at 10:00pm',
      reminder: true,
  
  },
  {
      id: 3,
      text: 'Shopping ',
      day: 'May 12th at 10:00am',
      reminder: false,
  
  },
  ] )

const addTask = (task) => {
  //console.log(task)
  const id = Math.floor(Math.random()* 10000)+1
  const newTask ={id, ...task}
  setTasks([...tasks, newTask])
}

  //delete task
  const deleteTask = (id) => {
    setTasks(tasks.filter((task) => task.id !==
    id))
    //if task.id not equal id
  }
  //Toggle Reminder
 const toggleReminder = (id)=> {
   setTasks(
     tasks.map((task) => 
     task.id === id ?{...task, reminder:
      !task.reminder} : task 
     ))
 }

  return (
    <div className='container'>
      <Header 
      onAdd={() => setShowAddTask
        (!showAddTask)}
         showAdd ={showAddTask}
         /> 
      {showAddTask && <AddTask onAdd ={addTask}/>}
      {tasks.length > 0? (
      <Tasks tasks={tasks}  onDelete=
      {deleteTask} onToggle={toggleReminder}/> 
      ):(
      'No task to show'
      ) }
    </div>
   
  )
}
 //if we want passC title in our header
export default App;
